import * as apiService from './api-service';
import {getSteemConfig} from '../config';


export async function getCommunity(tag: string, observer:string = ""): Promise<any> { 
  const response = await apiService.post({
    url: `${getSteemConfig()}`,
    body: {
      method: "bridge.get_community",
      id: 2,
      params: {"name":tag, "observer":observer} 
    }
  }); 

  return response;
}